import { render, staticRenderFns } from "./LoginAuthContainer.vue?vue&type=template&id=fb2bfce4&scoped=true"
import script from "./LoginAuthContainer.vue?vue&type=script&lang=js"
export * from "./LoginAuthContainer.vue?vue&type=script&lang=js"
import style0 from "./LoginAuthContainer.vue?vue&type=style&index=0&id=fb2bfce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2bfce4",
  null
  
)

export default component.exports